/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react';
import { useMemo } from 'react';
import PropTypes from 'prop-types';
import styleNames from '@pareto-engineering/bem/exports';
import { SVG } from "../../a";
import "./styles.scss";

// Local Definitions

const baseClassName = styleNames.base;
const componentClassName = 'logo';
const defaultTargetssquare = [{
  id: 'logo',
  target: 'logo'
}];
const contentMapSquare = {
  default: {
    sprite: '/logo_square.svg',
    viewBox: '0 0 39 39',
    targets: defaultTargetssquare
  }
};
const defaultTargetsWithName = [{
  id: 'logo_squares',
  target: 'logo_squares'
}, {
  id: 'logo_pareto',
  target: 'logo_pareto'
}];
const contentMapWithName = {
  default: {
    sprite: '/logo.svg',
    viewBox: '0 0 156 30',
    targets: defaultTargetsWithName
  }
};

/**
 * This is the component description.
 */
const Logo = ({
  id,
  className: userClassName,
  style,
  color,
  height,
  width,
  variant,
  strokeColor,
  square
  // ...otherProps
}) => {
  const contentMap = square ? contentMapSquare : contentMapWithName;
  const svgConfig = useMemo(() => contentMap[variant], [variant]);
  return /*#__PURE__*/React.createElement(SVG, {
    height: height,
    width: width,
    viewBox: svgConfig.viewBox,
    targets: svgConfig.targets,
    sprite: svgConfig.sprite,
    id: id,
    className: [baseClassName, componentClassName, `x-${color}`, `y-${strokeColor}`, userClassName].filter(e => e).join(' '),
    style: style
    // {...otherProps}
  });
};
Logo.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string),
  /**
   *  The color of the logo
   */
  color: PropTypes.string,
  /**
   * The height of the element
   */
  height: PropTypes.string,
  /**
   * The width of the element
   */
  width: PropTypes.string,
  /**
   * The variant to display. At the moment only `beta` is available.
   */
  variant: PropTypes.string,
  /**
   * The color of the svg stroke
   */
  strokeColor: PropTypes.string,
  /**
   * Whether the logo should have a name.
   */
  square: PropTypes.bool
};
Logo.defaultProps = {
  color: 'paragraph',
  height: '2em',
  variant: 'default',
  strokeColor: 'transparent',
  square: false
};
export default Logo;